import React, { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';

import { Actions, Categories, Labels } from '../../types/gtm';
import Title from '../../components/Title';
import { ItemGloboAds } from './components/ItemGloboAds';

import { DivContent, DivHeader, DivBox } from './styles';

const GloboAdsDetails = () => {
  const { user } = useAuth();

  window.dataLayer = window.dataLayer || [];

  useEffect(() => {
    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: Categories.DeleteAccount,
      event_action: Actions.Pageview,
      event_label: Labels.DeleteAccountGloboAdsPage,
      bd_suser_code: user?.globoId,
    });
  }, [user]);

  return (
    <>
      <DivHeader>
        <Title>Globo Ads</Title>
        <p>
          O vínculo com o Globo Ads precisa ser <strong>removido.</strong>{' '}
          <br /> Confira a seguir como remover o Globo Ads da sua conta:
        </p>
      </DivHeader>
      <DivBox>
        <DivContent className="mcv3-card">
          <ItemGloboAds />
        </DivContent>
      </DivBox>
    </>
  );
};

export default GloboAdsDetails;
